import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";

import { Loading } from "./utils";

const Matches = (props) => {
  const default_title = "LoL Esports Matches";
  const default_league_list = "ALL WCS LCK LPL LEC LCS VCS TCL CBLoL LJL LCL PCS LLA".split(
    " "
  );
  const default_size = 50;
  const url_hash = window.location.hash.match(
    default_league_list.join("|").toLowerCase()
  );

  const [league, setLeague] = useState(url_hash ? url_hash[0] : "all");
  const [json, setJson] = useState({});
  const [showAll, setShowAll] = useState(league === "all" ? true : false);
  const [count, setCount] = useState(0);

  const onClickLeague = (e) => {
    resetForm();
    setShowAll(false);
    setLeague(e.target.text.toLowerCase());
    if (e.target.text.toLowerCase() !== "all") {
      setCount(json.matches[e.target.text.toLowerCase()].length);
    }
  };

  const onClickShowAll = () => {
    setShowAll(true);
  };

  const resetForm = () => {
    const forms = document.querySelectorAll("input");
    Array.from(forms, (f) => (f.value = ""));
  };

  const filter = () => {
    if (!showAll) {
      setShowAll(true);
    }

    const rows = document.querySelectorAll(".matches-game");

    const filter_team = document.getElementById("filter_team").value;
    const filter_champion = document.getElementById("filter_champion").value;

    let count = 0;

    Array.from(rows, (row) => {
      const teams = row.querySelectorAll(".team-name");
      const picks = row.querySelectorAll(".picks img");

      let teams_str = "";
      let picks_str = "";

      Array.from(teams, (team) => (teams_str += team.innerText));
      Array.from(picks, (pick) => (picks_str += pick.alt));

      if (
        teams_str.match(new RegExp(filter_team, "i")) &&
        picks_str.match(new RegExp(filter_champion, "i"))
      ) {
        row.classList.remove("d-none");
        count += 1;
      } else {
        row.classList.add("d-none");
      }
      return false;
    });

    setCount(count);
  };

  const makeGameList = () => {
    if (!json) return [];

    // ALL
    if (league === "all") {
      let all = [];
      default_league_list
        .map((l) => l.toLowerCase())
        .map((league) => {
          if (league !== "all") {
            all = all.concat(json.matches[league].slice(0, default_size));
          }
          return false;
        });

      all = all
        .sort((a, b) => {
          if (a["timestamp"] > b["timestamp"]) {
            return -1;
          }
          if (a["timestamp"] < b["timestamp"]) {
            return 1;
          }
          return 0;
        })
        .slice(0, default_size);

      return all;
    }

    // a league
    const games = json.matches[league]
      .sort((a, b) => {
        if (a["timestamp"] > b["timestamp"]) {
          return -1;
        }
        if (a["timestamp"] < b["timestamp"]) {
          return 1;
        }
        return 0;
      })
      .slice(0, showAll ? json.matches[league].length : default_size);

    return games;
  };

  useEffect(() => {
    const f = async () => {
      const res = await fetch(
        "https://script.google.com/macros/s/" +
          process.env.REACT_APP_SHEET_ID +
          "/exec?q=matches"
      );
      const data = await res.json();
      setJson(data);
      console.log(data);

      if (league !== "all") {
        setCount(data.matches[league].length);
      }
    };
    f();
  }, [league]);

  return (
    <div className="common-bg-grey">
      <Helmet
        title={default_title}
        meta={[
          { name: "twitter:card", content: "summary" },
          {
            property: "og:url",
            content:
              "https://sightstones.netlify.app" + props.location.pathname,
          },
          { property: "og:title", content: default_title },
          {
            property: "og:image",
            content: "https://sightstones.netlify.app/img/ogp.png",
          },
        ]}
      />
      <Container className="matches bg-white">
        <header>
          <p className="text-right">Last Updated: {json.updated}</p>
          <h1 className="my-5 h2 text-center">{default_title}</h1>
        </header>
        <Row>
          <Col lg={12}>
            <div className="bg-light p-4">
              <div className="matches-leagues mb-4 text-center">
                <MatchesLeagues
                  leagues={default_league_list}
                  activeLeague={league}
                  onClickLeague={onClickLeague}
                />
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="team_search">
                        Team
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      id="filter_team"
                      aria-describedby="team_search"
                      onChange={filter}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-group mb-3">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="champion_search">
                        Champion
                      </span>
                    </div>
                    <input
                      type="text"
                      className="form-control"
                      id="filter_champion"
                      aria-describedby="champion_search"
                      onChange={filter}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          {!json.matches ? (
            <Loading />
          ) : (
            <Col lg={12}>
              <MatchesGames
                league={league}
                makeGameList={makeGameList}
                showAll={showAll}
                onClickShowAll={onClickShowAll}
                count={count.toString()}
                patch={json.patch}
              />
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

const MatchesLeagues = (props) => {
  return props.leagues.map((league) => {
    if (league.toLowerCase() === props.activeLeague) {
      return (
        <a
          className="btn btn-md btn-primary mr-2 mb-2"
          href={"#" + league.toLowerCase()}
          onClick={props.onClickLeague}
          key={league}
        >
          {league}
        </a>
      );
    } else {
      return (
        <a
          className="btn btn-md btn-outline-primary mr-2 mb-2"
          href={"#" + league.toLowerCase()}
          onClick={props.onClickLeague}
          key={league}
        >
          {league}
        </a>
      );
    }
  });
};

const MatchesGames = (props) => {
  const makeTitle = () => {
    const l = props.league === "cblol" ? "CBLoL" : props.league.toUpperCase();
    const count = " (" + props.count.toString() + " games)";

    if (props.league === "all") {
      return l;
    }

    return l + count.toString();
  };

  const toggleGame = (e) => {
    if (e.target.tagName === "A") return false;

    const elm = e.currentTarget.getElementsByClassName("details")[0];

    if (elm.className.match("d-none")) {
      elm.className = "details";
    } else {
      elm.className = "details d-none";
    }
  };

  const champNameToIcon = (name) => {
    let url = "";

    if (name === "Loss of Ban") {
      name = "Loss of ban " + Math.floor(Math.random() * Math.floor(100));
      url = "/img/lossofban.svg";
    } else if (name === "None") {
      name = "None" + Math.floor(Math.random() * Math.floor(100));
      url = "/img/none.svg";
    } else {
      name = name
        .replace(/'/, "")
        .replace(/ /g, "")
        .replace(/ChoGath/, "Chogath")
        .replace(/KaiSa/, "Kaisa")
        .replace(/KhaZix/, "Khazix")
        .replace(/LeBlanc/, "Leblanc")
        .replace(/VelKoz/, "Velkoz")
        .replace("Wukong", "MonkeyKing")
        .replace("Dr.Mundo", "DrMundo");

      url =
        "http://ddragon.leagueoflegends.com/cdn/" +
        props.patch +
        "/img/champion/" +
        name +
        ".png";
    }

    return <img src={url} key={name} alt={name} width="32px" height="32px" />;
  };

  return (
    <section className="mb-2">
      <h2 className="matches-league-title h5">{makeTitle()}</h2>
      {props.makeGameList().map((game) => (
        <div
          className="matches-game common-cursor"
          key={
            game["team1"]["name"] + game["team2"]["name"] + game["timestamp"]
          }
          onClick={toggleGame}
        >
          <div className="row">
            <div className="col-md-2 my-a d-flex align-items-center">
              <span className="mr-2">{game["date"].split(" ")[0]}</span>
            </div>
            <div className="col-md-2 d-flex align-items-center">
              <div
                className={
                  "team-name mb-0 w-100 h-100 d-flex align-items-center px-1 " +
                  (game["winner"] === "BLUE" ? "alert-success" : "alert-danger")
                }
              >
                <span className="text-nowrap text-truncate">
                  {game["team1"]["name"]}
                </span>
              </div>
            </div>
            <div className="col-md-2 d-flex align-items-center">
              <div
                className={
                  "team-name mb-0 w-100 h-100 d-flex align-items-center px-1 " +
                  (game["winner"] === "RED" ? "alert-success" : "alert-danger")
                }
              >
                <span className="text-nowrap text-truncate">
                  {game["team2"]["name"]}
                </span>
              </div>
            </div>
            <div className="col-md-3 picks-right">
              <span className="picks">
                {game["team1"]["picks"].map((name) => champNameToIcon(name))}
              </span>
            </div>
            <div className="col-md-3">
              <span className="picks">
                {game["team2"]["picks"].map((name) => champNameToIcon(name))}
              </span>
            </div>
          </div>

          <div className="details d-none">
            <div className="row m-2">
              <div className="col-md-6">
                <h5>{game["title"]} </h5>
              </div>
              <div className="col-md-6">
                <span className="mr-2">Game {game["game"]}</span>
                <span className="badge badge-info mr-2">
                  Patch {game["patch"]}
                </span>
                <a
                  className="mr-2"
                  href={game["mh"]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Match History
                </a>
                <a href={game["vod"]} target="_blank" rel="noopener noreferrer">
                  VOD
                </a>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <table className="table">
                  <thead>
                    <tr>
                      <th colSpan="2">{game["team1"]["name"]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Bans</td>
                      <td>
                        {game["team1"]["bans"].map((name) =>
                          champNameToIcon(name)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Picks</td>
                      <td>
                        {game["team1"]["picks_ordered"].map((name) =>
                          champNameToIcon(name)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Players</td>
                      <td>
                        {game["team1"]["players"]
                          .map((name) => name)
                          .join(" / ")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-md-6">
                <table className="table">
                  <thead>
                    <tr>
                      <th colSpan="2">{game["team2"]["name"]}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Bans</td>
                      <td>
                        {game["team2"]["bans"].map((name) =>
                          champNameToIcon(name)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Picks</td>
                      <td>
                        {game["team2"]["picks_ordered"].map((name) =>
                          champNameToIcon(name)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Players</td>
                      <td>
                        {game["team2"]["players"]
                          .map((name) => name)
                          .join(" / ")}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      ))}
      {props.showAll ? null : (
        <div
          onClick={props.onClickShowAll}
          className="d-block p-2 mt-2 bg-secondary text-light text-center common-cursor"
        >
          Show all
        </div>
      )}
    </section>
  );
};

export default Matches;
